const input = {
    username: 'Nome utente',
    password: 'Password',
    email: 'Email',
    phone_number: 'Numero di telefono',
    confirm_password: 'Conferma password',
    search_region_code: 'Codice regione di ricerca',
    backup_code: 'Codice di backup',
    code: 'Codice',
    label_with_optional: '{{label}} (Opzionale)',
    email_address: 'Indirizzo email',
    email_placeholder: 'Inserisci la tua email',
    enter_email: 'Inserisci l\'email',
};
export default Object.freeze(input);
